import Box from "@mui/material/Box";
import styled from "styled-components";

export const WrapperDialog = styled(Box)`
  filter: blur(5px);
  background-color: black;
`;
